import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Result } from "antd";
import Login from "./pages/Login";
import { PrivateRoute } from "./components/PrivateRout";
import MainNav from "./components/main-nav/main-nav";
import Logout from "./components/Logout";
import Thread from "./pages/Thread";
import Reports from "./pages/Reports";
import { getAppIsInitialize, getAuthIsLoading } from "./redux/selectors";
import { appInitialize, setFeedFilter, setUser } from "./redux/actions";
import { useAppDispatch } from "./redux/store/hooks";
import Main from "./pages/Main";
import ExpertsFull from "./pages/Experts";
import PersonalPage from "./pages/PersonalPage";
import Factory from "./pages/Factory";
import { DeepChat } from "deep-chat-react";
import { CommentOutlined } from "@ant-design/icons";
import { Catalog } from "./pages/Catalog";
import { Products } from "./pages/Products";
import Product from "./pages/Product";
import Search from "./pages/Search";
import HistorySearch from "./pages/History";
import Requests from "./pages/Reqests";
import Media from "./pages/Media";
import BanksPage from "./pages/BanksPage";


export const App = () => {
  const isInitialize = useSelector(getAppIsInitialize);
  const dispatch = useAppDispatch();
  const [openChat, setOpenChat] = useState(false);
  let type = localStorage.getItem("usertype");

  useEffect(() => {
    if (isInitialize) {
      dispatch(appInitialize());
    }
  }, [isInitialize]);

  const currentUser = localStorage.getItem("user");
  const currentFeedFilter = localStorage.getItem("feedFilter");
  const isLoading = useSelector(getAuthIsLoading);
  const history = [
    {
      role: "ai",
      text: "Здравствуйте! Здесь вы можете задать интересующий вас вопрос, наш менеджер ответит в ближайшее время",
    },
  ];

  if (currentUser) {
    dispatch(setUser(JSON.parse(currentUser)));
  }
  if (currentFeedFilter) {
    dispatch(setFeedFilter(JSON.parse(currentFeedFilter)));
  }

  let chatElementRef:any = useRef(null)

  chatElementRef.stream = true;
  chatElementRef.connect = {
    handler: (body:any, signals:any) => {
      try {
        fetch('custom-url').then((response) => {
          signals.onResponse({text: 'Handler response'}); // displays the response text message
        });
      } catch (e) {
        signals.onResponse({error: 'Error'}); // displays an error message
      }
    },
  };

  const NotFound = () => {
    return (
      <Result
        status="404"
        title="404"
        subTitle="Такой страницы не существует"
        extra={
          <a href="/main">
            <Button type="primary">На главную</Button>
          </a>
        }
      />
    );
  };

  return (
    <Router>
      {window.location.pathname != "/" && currentUser && !isLoading && (
        <MainNav />
      )}

      {type && <div className="chart-icon">
        <a onClick={(e) => setOpenChat(!openChat)} className="btn-img">
          <CommentOutlined />
        </a>
      </div>}
      {openChat && (
        <DeepChat
          demo={{response: (message) => {
            console.log("message", message.text)
            return {text: "Первый освободившийся менеджер ответит вам в ближайшее время"};
          }}}
          messageStyles={{
            "default": {
              "shared": {"bubble": {"borderRadius": "15px"}},
              "user": {"bubble": {"backgroundColor": "#6c00ff"}}
          }}}
          style={{ borderRadius: "10px" }}
          textInput={{ placeholder: { text: "Ваш вопрос..." } }}
          history={history}
          ref={chatElementRef}
        />
      )}
      <div>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/main" element={<Main />} />
            <Route path="/factory" element={<Thread />} />
            <Route path="/company" element={<Factory />} />
            <Route path="/factory/:Id" element={<Factory />} />
            <Route path="/sources" element={<ExpertsFull />} />
            <Route path="/lk" element={<PersonalPage />} />
            <Route path="/requests" element={<Requests />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/search" element={<Search />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product/:Id" element={<Product />} />
            <Route path="/history" element={<HistorySearch />} />
            <Route path="/media" element={<Media />} />
            <Route path="/banks" element={<BanksPage/>} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
};
